import React, {Component} from 'react';
import SVG from 'react-inlinesvg';

import call from '../images/icons/icon-call.svg';
import callGrey from '../images/icons/icon-call-grey.svg';
import email from '../images/icons/icon-email.svg';
import emailGrey from '../images/icons/icon-email-grey.svg';
import text from '../images/icons/icon-text.svg';
import textGrey from '../images/icons/icon-text-grey.svg';
import cancelled from '../images/icons/icon-cancelled.svg';
import confirmed from '../images/icons/icon-confirmed.svg';
import calendar from '../images/icons/IconCalendar.svg';
import calendarDay from '../images/icons/IconCalendarDay.svg';
import calendarWeek from '../images/icons/IconCalendarWeek.svg';
import xIcon from '../images/icons/icon-x.svg';

import dr from '../images/icons/IconDr.svg';
import settings from '../images/icons/IconSettings.svg';
import clients from '../images/icons/IconClients.svg';

import filter from '../images/icons/IconFilter.svg';
import help from '../images/icons/IconHelp.svg';
import more from '../images/icons/IconMore.svg';

import edit from '../images/icons/IconEdit.png';

import checkMark from '../images/icons/iconcheck.svg';
import arrow from '../images/arrow-left.png';

import clock from '../images/icons/IconClock.svg';
import clockActive from '../images/icons/IconClock-Active.svg';
import download from '../images/icons/icon-download.svg';

import trash from '../images/icons/icon-trash-grey.svg';
import copy from '../images/icons/icon-copy.svg';

import pendingTab from '../images/icons/icon-pending-tab.svg';

import pencil from '../images/icons/icon-pencil.svg';

import list from '../images/icons/list-svgrepo-com.svg';

import alertTag from '../images/icons/icon_alertflag.svg';

import notes from '../images/icons/icon-notes.svg';
import rx from '../images/icons/icon-rx.svg';

import { LoadingSpinner } from './BiopedUI';

export default class Icon extends Component{
	constructor(props){
		super(props);
		this.phone = this.call = call;
		this.phoneGrey = this.callGrey = callGrey
		this.email = email;
		this.emailGrey = emailGrey;
		this.text = text;
		this.textGrey = textGrey;
		this.cancelled = cancelled;
		this.confirmed = confirmed;
		this.calendar = calendar;
		this.calendarDay = calendarDay;
		this.calendarWeek = calendarWeek;
		this.dr = dr;
		this.settings = settings;
		this.clients = clients;
		this.x = xIcon;
		this.edit = edit;
		this.filter = filter;
		this.help = help;
		this.more = more;
		this.check = checkMark;
		this.arrow = arrow;
		this.clock = clock;
		this.clockActive = clockActive;
		this.download = download;
		this.delete = trash;
		this.copy = copy;
		this.pendingTab = pendingTab;
		this.pencil = pencil;
		this.list = list;
		this.alertTag = alertTag;
		this.notes = notes;
		this.rx = rx;


		//console.log("iconTest:", iconTest);
		//console.log("Icon Class:", this)
	}
	render(){
		let iconPath = this[this.props.icon];

		if(!iconPath){
			return ''; /* <div {... this.props}></div> */
		}

		if(iconPath.toLowerCase().indexOf('.svg') == -1){
			return(
				<img src={iconPath} {... this.props} alt={this.props.alt} />
			)
		}

		let view = (!this.props.isBusy) ? <SVG src={iconPath} {... this.props} alt={this.props.alt} />:<LoadingSpinner />;

		return(view)
	}
}



// WEBPACK FOOTER //
// ./src/components/Icon.js